import React from "react";

export default function PrivacyPolicy() {
  return (
    <main className="page">
      <h1>Privacy Policy</h1>
      <p style={{ fontSize: 14, color: "#666", marginBottom: 24 }}>
        Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
      </p>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Introduction</h2>
        <p>
          At 7BOX, we are committed to protecting your privacy. This Privacy Policy
          explains how we collect, use, disclose, and safeguard your information when
          you use our mobile application and services.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Information We Collect</h2>
        <h3 style={{ fontSize: 16, marginTop: 16, marginBottom: 8 }}>Personal Information</h3>
        <ul>
          <li>Name and contact information (phone number, email address)</li>
          <li>Delivery address and location data</li>
          <li>Payment information (processed securely through third-party providers)</li>
          <li>Account credentials and preferences</li>
        </ul>

        <h3 style={{ fontSize: 16, marginTop: 16, marginBottom: 8 }}>Usage Information</h3>
        <ul>
          <li>Order history and purchase patterns</li>
          <li>App usage data and interactions</li>
          <li>Device information and identifiers</li>
          <li>Location data (with your permission)</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>How We Use Your Information</h2>
        <ul>
          <li>Process and fulfill your orders</li>
          <li>Connect you with nearby stores and delivery partners</li>
          <li>Send order updates and notifications</li>
          <li>Improve our services and user experience</li>
          <li>Process payments and prevent fraud</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Data Sharing</h2>
        <p>
          We share your information only with:
        </p>
        <ul>
          <li><strong>Store Partners:</strong> To fulfill your orders</li>
          <li><strong>Delivery Partners:</strong> To deliver your purchases</li>
          <li><strong>Payment Processors:</strong> To process transactions securely</li>
          <li><strong>Service Providers:</strong> Who assist in operating our platform</li>
        </ul>
        <p style={{ marginTop: 12 }}>
          We do not sell your personal information to third parties.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your information,
          including encryption, secure servers, and regular security audits. However,
          no method of transmission over the internet is 100% secure.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your account</li>
          <li>Opt-out of marketing communications</li>
          <li>Withdraw consent for location tracking</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Cookies and Tracking</h2>
        <p>
          We use cookies and similar technologies to enhance your experience, analyze
          app usage, and personalize content. You can manage cookie preferences through
          your device settings.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Children's Privacy</h2>
        <p>
          7BOX is not intended for users under the age of 18. We do not knowingly
          collect personal information from children.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of
          any changes by posting the new policy on this page and updating the "Last
          updated" date.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 20, marginBottom: 12 }}>Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy or wish to exercise your
          rights, please contact us at:
        </p>
        <div
          style={{
            background: "#ffffff",
            padding: 16,
            borderRadius: 12,
            marginTop: 12,
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
          }}
        >
          <p style={{ margin: 0 }}>
            <strong>Email:</strong> privacy@7box.com<br />
            <strong>Support:</strong> support@7box.com
          </p>
        </div>
      </section>
    </main>
  );
}
